<template>
  <div class="container box" id="container-main">
    <div class="row" id="main-row">
      <div id="vapp">
        <div class="header">
          <h1 class="title">Logs</h1>
        </div>
        <div class="searchForm tile is-ancestor is-vertical">
          <div class="tile is-parent">
            <div class="tile is-child">
              <b-field label="From">
                <b-datetimepicker v-model="formProps.dateFrom" placeholder="Click to select..." editable>
                  <template slot="left">
                    <button class="button is-primary" @click="formProps.dateFrom = new Date()">
                      <b-icon icon="clock"></b-icon>
                      <span>Now</span>
                    </button>
                  </template>
                  <template slot="right">
                    <button class="button is-danger" @click="formProps.dateFrom = null">
                      <b-icon icon="close"></b-icon>
                      <span>Clear</span>
                    </button>
                  </template>
                </b-datetimepicker>
              </b-field>
              <b-field label="To">
                <b-datetimepicker v-model="formProps.dateTo" placeholder="Click to select..." editable>
                  <template slot="left">
                    <button class="button is-primary" @click="formProps.dateTo = new Date()">
                      <b-icon icon="clock"></b-icon>
                      <span>Now</span>
                    </button>
                  </template>
                  <template slot="right">
                    <button class="button is-danger" @click="formProps.dateTo = null">
                      <b-icon icon="close"></b-icon>
                      <span>Clear</span>
                    </button>
                  </template>
                </b-datetimepicker>
              </b-field>
            </div>
            <div class="tile is-child">
              <b-field label="Called From Number *">
                <b-input v-model="clid"></b-input>
              </b-field>
              <b-field label="Called To Number *">
                <b-input v-model="dnid"></b-input>
              </b-field>
              <b-field label="Customer *">
                <!--
              <b-select v-model="customer" expanded>
                <option v-for="customer in this.customers" :value="customer" :key="customer.disctools_id">{{ customer.customer_name }}</option>
              </b-select>
              -->
                <b-autocomplete v-model="searchTerm" :data="filteredDataObj" field="customer_name" open-on-focus
                  placeholder="e.g. joeg" @select="(option) => (customer = option)">
                  <template slot-scope="props">
                    <div class="media">
                      <div class="media-left">
                        <template v-if="props.option.disctools_id > 0">{{ props.option.disctools_id }}</template>
                        <template v-else></template>
                      </div>
                      <div class="media-content">
                        {{ props.option.customer_name }}
                      </div>
                    </div>
                  </template>
                </b-autocomplete>
              </b-field>
            </div>
          </div>
          <div class="tile is-parent">
            <div class="tile is-child">
              <button class="button is-primary is-fullwidth" @click="GetItems()">Submit</button>
            </div>
          </div>
        </div>
        <template>
          <b-table :data="this.calls" :loading="this.isLoading" hoverable detail-key="id" sticky-header>
            <b-table-column field="timestamp" label="Timestamp" sortable v-slot="props">
              {{ props.row.timestamp }}
            </b-table-column>
            <b-table-column field="hostname" label="Host" sortable v-slot="props">
              {{ props.row.hostname }}
            </b-table-column>
            <b-table-column field="instanceId" label="InstanceID" sortable v-slot="props">
              {{ props.row.instanceId }}
            </b-table-column>
            <b-table-column field="callid" label="CallId" sortable v-slot="props">
              {{ props.row.callid }}
            </b-table-column>
            <b-table-column field="CLID" label="CLID" sortable v-slot="props">
              {{ props.row.clid }}
            </b-table-column>
            <b-table-column field="DNID" label="DNID" sortable v-slot="props">
              {{ props.row.dnid }}
            </b-table-column>
            <b-table-column field="DTID" label="DTID" sortable v-slot="props">
              {{ props.row.dtid }}
            </b-table-column>
            <b-table-column field="actions" label="Actions" sortable v-slot="props">
              <button class="button is-medium is-success"
                @click="ViewLog(props.row.hostname, props.row.callid, props.row.uniqueId)">
                <b-icon icon="eye" size="is-small"></b-icon>
              </button>
            </b-table-column>
          </b-table>
        </template>
      </div>
    </div>
    <b-modal v-model="isDetailActive" has-modal-card trap-focus :destroy-on-hide="true" width="100%" aria-role="dialog"
      aria-modal>
      <template #default="props">
        <LogDetailComponent v-bind="formProps" @close="props.close"></LogDetailComponent>
      </template>
    </b-modal>
  </div>
</template>

<script>
const axios = require("axios");

import LogDetailComponent from "@/sections/voiceplus/components/LogDetailComponent.vue";

export default {
  components: {
    LogDetailComponent,
  },
  data: function () {
    return {
      customers: [],
      isDetailActive: false,
      regions: [],
      selected: {},
      isLoading: false,
      isNewItemActive: false,
      formProps: {
        dateFrom: new Date(),
        dateTo: new Date(),
        hostname: "",
        callid: "",
        logsUrl: "",
        region: "",
      },
      clid: "",
      dnid: "",
      customer: {},
      newApiUrl: "https://api.jeak.co.uk",
      logsUrl: "",
      calls: [],
      searchTerm: "",
    };
  },
  computed: {
    filteredDataObj() {
      return this.customers.filter((option) => (option.disctools_id + "-" + option.customer_name.toLowerCase()).indexOf(this.searchTerm.toLowerCase()) >= 0);
    },
  },
  methods: {
    dateFormatter(dt) {
      const mnth = ("0" + (dt.getMonth() + 1)).slice(-2);
      const day = ("0" + dt.getDate()).slice(-2);
      const hours = ("0" + dt.getHours()).slice(-2);
      const minutes = ("0" + dt.getMinutes()).slice(-2);
      return [dt.getFullYear(), mnth, day].join("-") + "T" + [hours, minutes, "00"].join(":");
    },
    GetItems: async function () {
      const from = this.dateFormatter(this.formProps.dateFrom);
      const to = this.dateFormatter(this.formProps.dateTo);
      this.isLoading = true;
      let clid = "";
      if (this.clid && this.clid != "") {
        clid = this.clid;
      }
      let dnid = "";
      if (this.dnid && this.dnid != "") {
        dnid = this.dnid;
      }
      const customerRegion = this.regions.filter((region) => region.id == this.customer.region_id)[0];
      let dtid = "";
      if (this.customer.disctools_id && this.customer.disctools_id != "" && this.customer.disctools_id != -1) {
        dtid = this.customer.disctools_id;
      }
      this.formProps.region = customerRegion.region_name;
      this.formProps.logsUrl = this.newApiUrl;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios
        .get(this.newApiUrl + "/logs/calls?clid=" + clid + "&dnid=" + dnid + "&dtid=" + dtid + "&from=" + from + "&to=" + to + "&region=" + customerRegion.region_name, config)
        .then((response) => {
          this.calls = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
          this.isLoading = false;
        });
    },
    ViewLog: function (hostname, callid, uniqueId) {
      this.formProps.hostname = hostname;
      this.formProps.callid = callid;
      this.formProps.uniqueId = uniqueId;
      this.isDetailActive = true;
    },
    GetCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(this.newApiUrl + "/customers", config);

      this.customers = [];
      this.customers.push({ disctools_id: -1, customer_name: "All" });
      this.customers = this.customers.concat(response.data);
      this.isLoading = false;
    },
    GetRegions: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios.get(this.newApiUrl + "/regions", config).then((response) => {
        let bufferedthis = this;
        response.data.forEach(function (value) {
          bufferedthis.regions.push(value);
        });
      });
    },
  },
  async mounted() {
    await this.GetCustomers();
    this.GetRegions();
    this.formProps.dateFrom = new Date();
    this.formProps.dateFrom.setHours(0, 0, 0, 0);
    this.formProps.dateTo = new Date();
    this.formProps.dateTo.setHours(23, 59, 59, 59);

    if (this.$route.query.clid) this.clid = this.$route.query.clid;
    if (this.$route.query.dnid) this.dnid = this.$route.query.dnid;
    if (this.$route.query.disctools_id)
      this.customer = this.customers.find((customer) => {
        return customer.disctools_id == parseInt(this.$route.query.disctools_id);
      });
    if (this.$route.query.from) this.formProps.dateFrom = new Date(this.$route.query.from);
    if (this.$route.query.to) this.formProps.dateTo = new Date(this.$route.query.to);
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}

.b-table {
  height: 500px;
}

.tile.is-parent {
  gap: 15px;
}

.searchForm {
  margin-top: 10px;
}</style>
